import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ComponentBase } from '~/infrastructure/component-base';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { LocationsService } from '~/services/modules/stocks/locations';
import { DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { PhysicalInventoryService } from '~/services/modules/stocks/stockPhysInventory.Service';
import { PhysicalInventorySummary } from '~/models/modules/PhysicalInventorySummary';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SharedService } from '~/services/sharedService';

@Component({
    selector: 'app-stock-physical-inventory',
    templateUrl: './physical-inventory.html',
    styleUrls: ['./physical-inventory.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StockPhysicalInventoryComponent extends ComponentBase implements OnInit {
  page: string = 'transaction-physical-inventory';
  title: string = 'Physical Inventory';
  showTextBox = false;
  @ViewChild('kendo_Start_Date_Time_Piker')
  kendoStartDateTimePiker: DateTimePickerComponent;
  @ViewChild('kendo_End_Date_Time_Piker')
  kendoEndDateTimePiker: DateTimePickerComponent;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: ComboBoxComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;

  _allSelected: boolean = false;
  _currentUser: UserSummary;
  _theme: string;
  _form: FormGroup;
  _invalidForm: boolean;
  _addClassActiveLocation: boolean = false;
  _addClassActiveGrid: boolean = false;
  _selectedLocations: any[] = [];
  _locations: any[] = [];
  _locationsFiltered: any[];
  _datePickerFormat: string;
  _costFormat: string;
  _dateEnabled: boolean;
  loggedInSiteId: any;

  public _physicalInventoryGridData: PhysicalInventorySummary[] = [];

  constructor(private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _securityService: SecurityService,
    private _locationsService: LocationsService,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _gridFieldsService: GridFieldsService,
    private _TransactionDateEditting: TransactionDateEditingService,
    private _physicalInventoryService: PhysicalInventoryService) {
    super();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._currentUser = this._securityService.currentUser;
  }
  closeTextbox(event: any) {
    //this.title=event.value;
    this._gridFieldsService.EditPageTitle(this.page, event.value).subscribe((data: any) => {
      this.title = data.titleName;
      this._sharedService.TitleChanged.emit(true);
    });
    this.showTextBox = false;
  }
  showTextbox() {
    this.showTextBox = true;
    //document.getElementById('titleTextBox').focus();
    //this.titleTextBox.nativeElement.focus();
  }
  //#region  ngOnInit
  ngOnInit() {
    this._gridFieldsService.getPageByName(this.page).subscribe((data) => {
      if (data.titleName) {
        this.title = data.titleName;
      }
    });
    this._initForm();
    this._OpenAccount();
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    this.loggedInSiteId = JSON.parse(loggedInAccountSites)[0].siteId;
    this._LoadLocation(this.loggedInSiteId);
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this.getDateEnabledOption();
  }
  //#endregion

  //#region  _OpenAccount
  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {
        this.kendoStartDateTimePiker.focus();
        this.kendoStartDateTimePiker.toggle();
      }, 100);
    }
  }
  //#endregion

  //#region  _LoadLocation
  _LoadLocation(siteId: number) {

    let siteModel = { siteId: siteId }

    return this._locationsService.getLocationsByAccounts(siteModel).subscribe((data: any) => {
      //.getLocationListingBySite(siteId)
      this._locations = data;
      this._locationsFiltered = data;
    });
  }
  //#endregion

  //#region _onLocationChange
  _onLocationChange(e: any) {
    this._selectedLocations = e;
  }
  //#endregion

  //#region  _initForm
  private _initForm() {
    this._form = this._fb.group({
      startDate: new Date(),
      endDate: new Date(),
    });
  }
  //#endregion

  //#region  _onSave
  _onSave(e: any) {
    let data = this._physicalInventoryGridData.filter(c => c.adjust && c.quantityToPost >= 0);
    if (data.length > 0) {
      if (window.confirm("Are you sure you want to apply change to all checked items?")) {
        this._physicalInventoryService.UpdateStockPhysInvList(data).subscribe((res) => {
          // let dataBack = res.data as PhysicalInventorySummary[];
          // dataBack.forEach(element => {
          //   let index = this._physicalInventoryGridData.findIndex(c => c.id == element.id);
          //   this._physicalInventoryGridData.splice(index, 1);
          // });
          this._physicalInventoryGridData = [];
        });
      }
    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add the items you want to Physical Inventory.',
        withoutConfirm: true
      });
    }
  }
  //#endregion

  //#region  _onClear
  _onClear() {

    this._form.setValue({
      startDate: null,
      endDate: null,
    });

    this.kendoStartDateTimePiker.value = null;
    this.kendoEndDateTimePiker.value = null;
    this._selectedLocations = [];
    this._LoadLocation(this.loggedInSiteId);
    this._physicalInventoryGridData = [];
  }
  //#endregion

  //#region  _onStateChanges
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    }
    else {
      this._layoutManager.applyOverly();
    }
  }
  //#endregion

  //#region  ngOnDestroy
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  //#endregion

  //#region  _startDateSubmited
  _startDateSubmited() {
    setTimeout(() => {
      this.kendoStartDateTimePiker.blur();
      this.kendoEndDateTimePiker.focus();
      this.kendoEndDateTimePiker.toggle();
    });
  }
  //#endregion

  //#region  _endDateSubmited
  _endDateSubmited() {
    setTimeout(() => {
      this.kendoEndDateTimePiker.blur();
      this._addClassActiveLocation = true;
    });
  }
  //#endregion

  //#region  Functions Select

  //#region  _selectAdjustAll
  _selectAdjustAll() {
    this._allSelected = !this._allSelected;

    this._physicalInventoryGridData.forEach((element) => {
      element.adjust = this._allSelected;
    });

    this._CheckSelectAll();
  }
  //#endregion

  //#region _checkAdjust
  _checkAdjust(data: any) {
    var index = this._physicalInventoryGridData.indexOf(data);
    this._physicalInventoryGridData[index].adjust = !this._physicalInventoryGridData[index].adjust;
    this._CheckSelectAll();
  }
  //#endregion

  //#region  CheckSelectAll
  _CheckSelectAll() {
    this._allSelected =
      this._physicalInventoryGridData.length == this._physicalInventoryGridData.filter((x) => x.adjust).length;
  }
  //#endregion
  //#endregion

  //#region  _gridclicked
  _gridclicked() {
    // this._addClassActiveLocation = false;
    // this.kendoStartDateTimePiker.toggle(false);
    // this.kendoStartDateTimePiker.blur();
    // this.kendoEndDateTimePiker.toggle(false);
    // this.kendoEndDateTimePiker.blur();
    // this._addClassActiveGrid = true;
  }
  //#endregion

  //#region  _listboxClicked
  _listboxClicked() {
    this._addClassActiveLocation = true;
    this.kendoStartDateTimePiker.toggle(false);
    this.kendoStartDateTimePiker.blur();
    this.kendoEndDateTimePiker.toggle(false);
    this.kendoEndDateTimePiker.blur();
    this._addClassActiveGrid = false;
  }
  //#endregion

  //#region  _startDateOpened
  _startDateOpened() {
    this._addClassActiveLocation = false;
    this._addClassActiveGrid = false;
  }

  //#endregion

  //#region  _endDateOpened
  _endDateOpened() {
    this._addClassActiveLocation = false;
    this._addClassActiveGrid = false;
  }
  //#endregion

  //#region  getDateEnabledOption
  getDateEnabledOption() {
    this._TransactionDateEditting.getTransactionDateEditing('get-data').subscribe((x: any) => {
      if (x)
        this._dateEnabled = x.transactionDateEditing;
    });
  }
  //#endregion

  //#region  _onAllVariance
  _onAllVariance() {
    this._allSelected = false;

    if (this._form.valid && this._selectedLocations.length > 0) {
      this._physicalInventoryGridData = [];
      var locIdList = this._selectedLocations.map((c) => c.id);
      this._physicalInventoryService.GetStockPhysInvByDateAndLoc(locIdList, this._form.value).subscribe((res: any) => {
        let data = res.data as PhysicalInventorySummary[];

        this._physicalInventoryGridData = data
          .filter(p => p.stockLocation?.availability > 0)
          .map(p => {
            p.quantityToPost = (p.quantityToPost === 0 || p.quantityToPost === null || p.quantityToPost === undefined) ? p.quantity : p.quantityToPost;
            return p;
          });

        // this._physicalInventoryGridData = res.data as PhysicalInventorySummary[];
      });
    }
  }
  //#endregion

  //#region  QuantityToPost
  _QuantityToPost(data: any, event: any) {
    var index = this._physicalInventoryGridData.indexOf(data);
    this._physicalInventoryGridData[index].quantityToPost = event;
  }
  //#endregion
}
